import Quill from 'quill/core';

const moveCursorToNeighborLine = (
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  quill: any,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  blot: any,
  direction: 'up' | 'down',
) => {
  const index: number = blot.offset(blot.scroll);
  quill.setSelection(
    direction === 'up' ? index - 1 : index + 1,
    0,
    Quill.sources.USER,
  );
};

export default moveCursorToNeighborLine;
